var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('correlativas-a-b-m',{attrs:{"headers":_vm.headers,"materia_id":_vm.materia_id}})}
var staticRenderFns = []

export { render, staticRenderFns }